// src/components/ui/molecules/CategoryPicker.tsx
import React, { JSX } from 'react';
import { GoMultiSelect } from 'react-icons/go';
import { FaPepperHot, FaDollarSign, FaCanadianMapleLeaf } from 'react-icons/fa';
import { FaEarthAmericas, } from 'react-icons/fa6';
import { IoMdBonfire } from 'react-icons/io';
import { GiStrong, GiGlassCelebration } from "react-icons/gi";
import { MdOutlineWbSunny } from "react-icons/md";

export type CategoryPickerProps = {
  categories: Array<{ key: string; label: string }>;
  selected: string | null;
  onSelect: (categoryKey: string) => void;
  size?: 'sm' | 'md';
};

const ICON_MAP: Record<string, JSX.Element> = {
  diet:             <GoMultiSelect />,
  cuisine:          <FaEarthAmericas />,
  spice_level:      <FaPepperHot />,
  technique:        <IoMdBonfire />,
  cost_and_effort:  <FaDollarSign />,
  nutrition:        <GiStrong />,
  meal_type:        <MdOutlineWbSunny />,
  season:           <FaCanadianMapleLeaf />,
  occasion:         <GiGlassCelebration />,   
  // add others if you like...
};

export function CategoryPicker({
  categories,
  selected,
  onSelect,
  size = 'sm',
}: CategoryPickerProps) {
  const padding = size === 'sm' ? 'px-2 py-0.5' : 'px-3 py-1';
  const fontSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1 px-1 hide-scrollbar">
      {categories.map(({ key, label }) => {
        const lc = key.toLowerCase();
        const icon = ICON_MAP[lc];
        const isActive = selected === key;
        return (
          <button
            type="button"
            key={key}
            onClick={() => onSelect(key)}
            className={[
              'inline-flex items-center space-x-1 whitespace-nowrap flex-shrink-0 rounded-full',
              padding,
              isActive ? 'bg-primary text-white' : 'bg-gray-100 text-gray-800',
              fontSize,
            ].join(' ')}
          >
            {icon && React.cloneElement(icon, { className: 'w-4 h-4' })}
            <span className="capitalize">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
